module.exports = __webpack_public_path__ + "img/pic-talk-slide4.311c253d.png";